import clsx from 'clsx';

import { TreatmentCheckInStatus } from '@/services/types/treatment-types';

interface CheckInStatusBadgeProps {
  status: TreatmentCheckInStatus;
}

function getBadgeConfig(status: TreatmentCheckInStatus) {
  switch (status) {
    case TreatmentCheckInStatus.NEEDS_REVIEW:
      return {
        label: 'Needs Review',
        className: 'bg-amber-100 text-amber-700',
      };
    case TreatmentCheckInStatus.COMPLETED:
      return {
        label: 'Completed',
        className: 'bg-emerald-100 text-emerald-700',
      };
    case TreatmentCheckInStatus.PROCESSING:
      return { label: 'Processing', className: 'bg-blue-100 text-blue-700' };
    case TreatmentCheckInStatus.DRAFT:
    default:
      return { label: 'Draft', className: 'bg-gray-100 text-gray-600' };
  }
}

export const CheckInStatusBadge = ({ status }: CheckInStatusBadgeProps) => {
  const { label, className } = getBadgeConfig(status);
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        className,
      )}
    >
      {label}
    </span>
  );
};
